import { render } from "./AboutInfo.vue?vue&type=template&id=2d563bca"
import script from "./AboutInfo.vue?vue&type=script&lang=js"
export * from "./AboutInfo.vue?vue&type=script&lang=js"

import exportComponent from "../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__